import React from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import { Header } from "@/components/Header/Header";
import { InviteReferralsSection } from "@/components/InviteReferralsSection/InviteReferralsSection";
import { StatisticsSection } from "@/components/StatisticsSection/StatisticsSection";
import { TabsMenu } from "@/components/TabsMenu/TabsMenu";
import { useMenuTabStore } from "@/store/menuTabStore";
import { useReferalsDataContext } from "@/store/ReferalsProvider";

export const MainPage = () => {
  const activeTab = useMenuTabStore((s) => s.activeTab);
  const { userStatus } = useReferalsDataContext();

  return (
    <FlexColumn gap={20}>
      <Header />
      {userStatus?.is_blogger && <TabsMenu />}

      {activeTab === "invite" && <InviteReferralsSection />}
      {activeTab === "statistics" && <StatisticsSection />}
    </FlexColumn>
  );
};
